import { useState,  useContext, useEffect } from 'react';
import { useSubmit, useNavigate, useLocation } from 'react-router-dom';

import useUploadManager from "../utils/upLoadManager";
import FormHelper from '../components/UI/FormHelper';
import { ensureToken, uploadFile, getUploadedFiles} from '../utils/api';
import MenuContext from '../store/MenuContext';
import TestInfoClasses from '../components/Tests/TestInfo.module.css';

const AAOE = (props) => {

	let aaoearray=props.aaoes;
	let aaoeAnswers=props.aaoeA;
	let onSubmit=props.onSubmit;
	let onButtonClick=props.onButtonClick;
	const [formError,setFormError] = useState({});
	const [selectedFile, setSelectedFile] = useState({});
    const [uploadedFiles, setUploadedFiles] = useState({});
	const [fileStruc,setFileStruc]=useState({});
	const [token, setToken] = useState(() => sessionStorage.getItem("token"));
	const submit = useSubmit();
	const navigate = useNavigate();
	const location = useLocation();
	const menuTheme = useContext(MenuContext);
	
	useEffect(() => { fetchDocuments(); }, []); 

	const fetchDocuments = async () => { 
		try { 
			const data = await getUploadedFiles(); 
			setFileStruc(data);
			} 
			catch (err) { console.error(err); } };
	const {
		uploadedFileName,
		handleSelectedFile,
		hasPendingFile,
		uploadPendingFiles,
	  } = useUploadManager({
		onUploadSuccess: async () => {
		  await fetchDocuments();
		},
		onUploadError: (fieldName, err) => {
		  console.error(`Upload failed for ${fieldName}`, err);
		},
  });
	const aaoeids = aaoearray.map((item) => (
			item.QuestID
			));	

	const tfHandler = (tferror) => {
		let newtfError={...tferror}
		setFormError(newtfError);
	};

	const handleSubmit = async (event) => {
	  event.preventDefault();

	  if (Object.keys(formError).length !== 0) return;

	  const fd = new FormData(event.target);

	  try {


		  const obj = Object.fromEntries(fd.entries());
		  console.log(obj);
		  onSubmit(obj);
		} catch (err) {
			console.log(err);
		  console.error("Submit failed:", err);
		}
	};
		const handleFileChange = async (fieldName, file) => {
		  setSelectedFile((prev) => ({
			...prev,
			[fieldName]: file || null,
		  }));

		  const token = sessionStorage.getItem("token");
		  if (token && file) {
			await doUpload(fieldName, file);
		  }
		};

	  const doUpload = async (fieldName, file) => {
		if (!file) return;

		await uploadFile({ file, navigate });

		setUploadedFiles((prev) => ({
		  ...prev,
		  [fieldName]: file.name,
		}));

		setSelectedFile((prev) => ({
		  ...prev,
		  [fieldName]: null,
		}));
	  };

	  const handleFileReady = async (fieldName) => {
		const file = selectedFile[fieldName];
		if (!file) return;

		if (token) {
		  await doUpload(fieldName, file);
		}
		// no token: do nothing
		// file stays in state until login occurs
	  };

	  useEffect(() => {
		const interval = setInterval(() => {
		  const currentToken = sessionStorage.getItem("token");
		  setToken(currentToken);
		}, 500);

		return () => clearInterval(interval);
	  }, []);

	  useEffect(() => {
		if (!token) return;

		Object.entries(selectedFile).forEach(([fieldName, file]) => {
		  if (file) {
			doUpload(fieldName, file).catch((err) => {
			  console.error(`Upload failed for ${fieldName}:`, err);
			});
		  }
		});
	  }, [token]);
    return (
    	<div className={TestInfoClasses.testInfoContent}>
				<br/><br/>
				<h2 className={TestInfoClasses.testTitle} >Answer Questions for {aaoearray[0].TestName}</h2>
				<p >
					Fill out all required (*) fields prior to clicking save.
				</p>
				<form onSubmit={handleSubmit} encType="multipart/form-data">
					<FormHelper TF={aaoearray} data={aaoeAnswers} onTF={tfHandler} 
						uploadedFileName={uploadedFileName}
						onFileSelect={handleSelectedFile}
						hasPendingFile={hasPendingFile}
					/>
					<div className={TestInfoClasses.buttonArea}>  
				  		<div className={TestInfoClasses.navArea}>
							<button  className={TestInfoClasses.buttonDarkBlue} onClick={onButtonClick}  >
						  		Cancel 
						  	</button>
						  	<button  className={TestInfoClasses.buttonDarkBlue} type="submit">
								Save Answers
						  	</button>
						  	
						 </div>
				 	  </div> 
					<input type="hidden" value={aaoearray[0].TestCode} name="TestCode" />
					<input type="hidden" value={aaoeids} name="AaoeID" />
				</form>
		</div>

	);
};

export default AAOE;

